import { emptyApi } from "./emptyApi";

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getOnBoarding: build.query<
      {
        key: string;
        status_display: string;
        uuid: string;
      },
      { step_key: string }
    >({
      query: ({ step_key }) => ({
        url: `/api/inkle/users/product_step/`,
        params: { step_key },
      }),
      providesTags: (result) => (result ? ["AI_ONBOARDING"] : []),
    }),
    updateOnBoarding: build.mutation<
      {
        key: string;
        status_display: string;
        uuid: string;
      },
      { uuid: string; step_key: string; status: string }
    >({
      query: ({ uuid, step_key, status }) => ({
        url: `/api/inkle/users/product_step/${uuid}`,
        method: "PATCH",
        // params: { uuid },
        body: { step_key, status },
      }),
      invalidatesTags: ["AI_ONBOARDING"],
    }),
    createAIChannel: build.mutation<
      {
        channel_id: string;
      },
      { groupId: string; step_key: string; status: string }
    >({
      query: ({ groupId, step_key, status }) => ({
        url: `/api/inkle/company/group/${groupId}/ai-channel/`,
        method: "POST",
        body: { step_key, status },
      }),
      invalidatesTags: ["AI_ONBOARDING", "Groups"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetOnBoardingQuery,
  useUpdateOnBoardingMutation,
  useCreateAIChannelMutation,
} = extendedApi;
